<template>
<div class="tags-search-bar">
  <div v-for="row in list" :key="row.tagId" class="tag"
       @click="handleSearch(row)">{{row.tagName}}</div>
</div>
</template>

<script>
export default {
  name: "TagsSearchBar",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    handleSearch(row) {
      this.$emit("search", row)
    }
  }
}
</script>

<style lang="less" scoped>
.tags-search-bar {
  overflow: hidden;
  padding: 7px 20px 14px;
  background-color: #eaeaea;
  & .tag {
    float: left;
    height: 17px;
    line-height: 17px;
    margin: 7px 10px 0 0;
    font-size: .6rem;
    border-radius: 16.5px;
    width: 45px;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    
    background-color: #d0b975;
    color: #FFFFFF;
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
